
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import { useSelector } from 'react-redux';
import * as actionType from './wareHouseActionType'
const config = JSON.parse(Config);
const apiInterface = config['api1'];

export const addStoreView = () => ({
  type: actionType.ADD_WAREHOUSE_VIEW_MODE,
  payload: 'Add'
});
export const addStore = (data) => ({
  type: actionType.ADD_WAREHOUSE,
  payload: data
});


export const updateStoreView = () => ({
  type: actionType.UPDATE_WAREHOUSE_VIEW_MODE,
  payload: 'Update'
});
export const getStores_sucess = (data) => ({
  type: actionType.GET_WAREHOUSE_LIST,
  payload: data,
})
export const FilterdStore = (data) => ({
  type: actionType.GET_SELECTED_WAREHOUSE,
  payload: data,
})
export const StoreStart = () => ({
  type: actionType.GET_WAREHOUSE_LIST_START,
  payload: true,
})

export const WareHousMessage = (message) => ({
  type: actionType.GET_WAREHOUSE_LIST_ERROR,
  payload: message,
})

export const update_store_success = (payload) => ({
  type: actionType.UPDATE_WAREHOUSE_DATA,
  payload
})

export const load_store_success = (payload) => ({
  type: actionType.LOAD_WAREHOUSE_DATA,
  payload
})

export const api_success = (payload) => ({
  type: actionType.API_SUCCESS_WAREHOUSE,
  payload
})
export const isEditWareHouse = (payload) => ({
  type: actionType.IS_WAREHOUSE_EDIT,
  payload
})
export const isWareHouseCreate = (payload) => ({
  type: actionType.IS_WAREHOUSE_CREATE,
  payload
})
export const isWareHouseList = (payload) => ({
  type: actionType.IS_WAREHOUSE_LIST,
  payload
})
export const isWareHouseView = (payload) => ({
  type: actionType.IS_WAREHOUSE_VIEW,
  payload
})

export const getWareHouseList = (userId,type) => async (dispatch) => {

  dispatch(StoreStart);
  const data = {
    'store_type_id': type,
    'fedid': userId
  }
  
  ApiGateWay.PostCall1(`${apiInterface}/StoreInfo/loadstoresinitialdata`, data)
    .then((response) => {
      if (response) {
        let Stores = [];
        // response[11].Table2.forEach() -- StoreType
        response[11].Table12.forEach((element, index) => {
          Stores.push({
            key: index + 1,
            storeId:element.store_id,
            CostCenter: element.store_costcenter,
            BuildingType_name: element.building_type_name,
            StoreName:element.store_name,
            StoreType:element.store_type,
            StoreCityId:Number(element.store_city_id),
            StoreAddress:element.store_address,
            Zone: element.store_zone_id,
            ZoneName: element.zone_name,
            City: element.city_name,
            StateId:Number(element.store_state_id),
            TotalBuitlArea:element.prop_builtup_area,
            TotalSalesArea:element.prop_sales_area,
            BuildingType:Number(element.building_type),
            CarParking:element.prop_car_parking,
            NumberOfCarParking:element.prop_number_of_cars_parking,
            NumberOfTwoWheelerParking:element.prop_number_of_two_wheelars_parking,
            NumberOfStackParking:element.prop_number_of_stack_parking,
            PropertyType:element.property_type,
            GstNumber:element.gst_number,
            PlayGroundConcrete:element.prop_playground_concreate,
            PlayGroungSize:element.prop_playground_concreate_size,
            PlayGroundTurf:element.prop_playground_turf,
            PlayGroundTurfSize:element.prop_playground_turf_size,
            StoreOpeningDate:element.landlard_store_opening_date,
            LeaseStartDate:element.landlard_lease_start_date,
            LeaseEndDate:element.landlard_lease_end_date,
            WarrantyDate:element.prop_landlard_warranty_end_date,
            LandLordName:element.landlard_name,
            LandLordEmail:element.landlard_email,
            LandLordContactNumber:element.landlard_contact_number,
            LandLordAltNumber:element.landlard_alter_contact_number,
            StoreManagerEmail:element.store_manager_email,
            ZOMCoachEmail:element.zone_operation_maintenance_coach_email,
            CMEmail:element.construction_manager_email, 
            ProductLeaderEmail:element.product_leader_email,
            SOREmail:element.store_operation_referent_email,


            StoreOpReferentNumber:element.store_operation_referent_mobile_number,
            StoreOpRefName:element.store_operation_referent_name,
            StoreOpRefId:element.store_operation_referent_employee_id,

            StoreMgrName:element.store_manager_name,
            StoreMgrNumber:element.store_sm_mobile_number,
            StoreMgrId:element.store_sm_employee_id,


            ZoneOpMCoachName:element.zone_operation_maintenance_coach_name,
            ZoneOpCoachNumber:element.store_zomc_mobile_number,
            ZoneOpCoachId:element.store_zomc_employee_id,

            constructionMgrName:element.construction_manager_name,
            counsturtionMgrMobNumber:element.store_cm_mobile_number,
            ConstructionMgrId:element.store_cm_employee_id,

            MaintainceLeaderName:element.product_leader_name,
            MaintainceLeaderNumber:element.store_maintaince_lead_mobile_number,
            MaintainceLeaderId:element.store_maintaince_lead_employee_id,
            MaintainenceChecklistOne: element.maintainence_checklist_one,

            Status:element.store_active_flag ==1?'Active':'In Active'
          })
        });

        const storeTypes = response[1]?.Table2?.map(item => {
          return {
            'id': item.code_id,
            'value': item.code_value
          }
        });

        const States = response[2]?.Table3?.map(item => {
          return {
            'id': item.code_id,
            'value': item.code_value
          }
        });

        const Zones = response[3]?.Table4?.map(item => {
          return {
            'id': item.code_id,
            'value': item.code_value
          }
        });

        const cities = response[4]?.Table5?.map(item => {
          return {
            'id': item.code_id,
            'value': item.code_value
          }
        });

        const propertyTypes = response[5]?.Table6?.map(item => {
          return {
            'id': item.name,
            'value': item.value
          }
        });
        const buildingTypes = response[12]?.Table13?.map(item => {
          return {
            'id': item.building_type_id,
            'value': item.building_type_name
          }
        });

        const StoreOperationalList = response[8]?.Table9;
        const StoreManagerList = response[8]?.Table9;
        const ZonalManagerList = response[9]?.Table10;
        const  MaintenanceLeaderList=response[10]?.Table11
        const AllowWareHouse= response[13]?.Table14
        const StoreData = { Stores, storeTypes, States, Zones, cities, propertyTypes, StoreOperationalList, StoreManagerList, ZonalManagerList,buildingTypes,AllowWareHouse }
        dispatch(getStores_sucess(StoreData))
        
      }
    })
    .catch((e) => {
      dispatch(WareHousMessage('Something went wrong please try again after sometime'))
    })

}


export const updateStoreInfo = (data) => async (dispatch) => {
  
  dispatch(StoreStart());
  
  ApiGateWay.SaveData(`${apiInterface}/StoreInfo/updatestoreinfo`, data)
    .then(response => {
      dispatch(api_success(response[1]?.Table2[0].status_code))
      if(response[0]?.Table1[0].status_code=='000'){
        dispatch(WareHousMessage(response[1]?.Table2[0].status_msg))
      }else{
        dispatch(WareHousMessage(response[0]?.Table1[0].status_msg)) 
      }
    
    }).
    catch(error => {
      dispatch(WareHousMessage('Something went wrong please try again after sometime'))
    })
}
export const addStoreInfo = (data) => async (dispatch) => {
  dispatch(StoreStart()); 
  ApiGateWay.SaveData(`${apiInterface}/StoreInfo/updatestoreinfo`, data)
    .then(response => {
      dispatch(api_success(response[1]?.Table2[0].status_code))
      if(response[1]?.Table2[0].status_code=='000'){
        dispatch(WareHousMessage(response[1]?.Table2[0].status_msg))
      }else{
        dispatch(WareHousMessage(response[1]?.Table2[0].status_msg)) 
      }
    
    }).
    catch(error => {
      dispatch(WareHousMessage('Something went wrong please try again after sometime'))
    })
}


export const storeViewDetails = (storeId) => (dispatch) => {
  const data = {
    'store_id': storeId,
  }
  dispatch(StoreStart());
  ApiGateWay.PostCall1(`${apiInterface}/StoreInfo/loadonestoreinfo`, data)
    .then(response => {
      const lotA = response[1]?.Table2;
      const lotB = response[2]?.Table3;
      const storeInfo={lotA,lotB}
      // console.log(storeInfo,'storeInfo');
      dispatch(load_store_success(storeInfo))
    }).catch(err => {
      dispatch(WareHousMessage('Something went wrong please try again after sometime'))
    })
}

export const getSelectedStoreList = (data) => (dispatch) => {
   dispatch(FilterdStore(data))
}
export const isEdit=(data)=>(dispatch)=>{
  dispatch(isEditWareHouse(data))
}
export const addWareHouse=(data)=>(dispatch)=>{
  dispatch(isWareHouseCreate(data))
}
export const WareHouseList=(data)=>(dispatch)=>{
  dispatch(isWareHouseList(data))
}
export const showWareHouseView=(data)=>(dispatch)=>{
  dispatch(isWareHouseView(data))
}
